import { formatTaxRatePercent } from "@/lib/articleConstants";
import type { Account } from "@/types/camping";

export function accountHasTaxRate(account: Account | null | undefined): boolean {
  return account != null && account.tax_rate_percent != null && account.tax_rate_percent !== "";
}

export function AccountTaxRateNotice({ account }: { account: Account | null }) {
  if (!account) {
    return (
      <p className="text-sm text-label-secondary">
        Der Mehrwertsteuersatz kommt vom Buchungskonto. Sobald ein Konto zugeordnet ist, gilt
        dessen Satz.
      </p>
    );
  }
  if (!accountHasTaxRate(account)) {
    return (
      <p className="text-sm text-status-red">
        Konto {account.account_number} hat noch keinen Mehrwertsteuersatz. Bitte unter Stammdaten
        → Konten zuweisen.
      </p>
    );
  }
  return (
    <p className="text-sm text-label-secondary">
      Mehrwertsteuer{" "}
      <span className="font-medium tabular-nums text-label">
        {formatTaxRatePercent(account.tax_rate_percent)} %
      </span>{" "}
      aus Konto {account.account_number}
    </p>
  );
}
